import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

// images
import avatarPlaceholder from "assets/img/avatar-placeholder.jpg";

//styles
import { convertPxToRem } from "frontend/components/helpers";
const AvatarStyled = styled.img`
    display: block;
    border-radius: 50%;
    ${({ $size }) => {
        return css`
            width: ${convertPxToRem($size)};
            height: ${convertPxToRem($size)};
        `;
    }}
`;

/**
 * getSrcWithFallback: When falling back, NextJS and SPA handle image imports differently.
 * @param {String} avatarUrl
 * @returns {String} final resolved string
 */
const getSrcWithFallback = avatarUrl => {
    return (
        avatarUrl ||
        (typeof avatarPlaceholder === "object"
            ? avatarPlaceholder?.src
            : avatarPlaceholder) ||
        ""
    );
};

// component
const Avatar = ({ user, alt = "User profile image", className, size = 40 }) => {
    const { avatarUrl, username } = user ?? {};

    return (
        <AvatarStyled
            title={username || alt}
            className={className}
            alt={alt}
            src={getSrcWithFallback(avatarUrl)}
            $size={size}
        />
    );
};

export default Avatar;

// prop-types
Avatar.propTypes = {
    user: PropTypes.object,
    alt: PropTypes.string,
    size: PropTypes.number,
    className: PropTypes.string
};
